import * as Y from 'yjs'

import type { Collaborator } from './Collaborator'
import type { ObserveEvent } from '@rehaje/reactive'
import type { TRecord } from '@rehaje/shared'

export const YArray = Y.Array<any>
export const YDoc = Y.Doc
export const YMap = Y.Map<any>
export const YUndoManager = Y.UndoManager

export interface CollaboratorOptions extends DebugOptions, YDocOptions {
  captureTimeout?: number
  name?: string
  onDocChanged?: DocChangedListener
  onReactiveChanged?: ReactiveChangedListener
  onStackAdded?: YStackItemListener
  onStackPopped?: YStackItemListener
  onStackUpdated?: YStackItemListener
  plugins?: CollaboratorPlugin | CollaboratorPlugin[]
}
export interface CollaboratorPlugin {
  (context: Collaborator): CollaboratorProvider
}
export interface CollaboratorProvider {
  connect(): void
  disconnect(): void
}
export interface DebugOptions {
  onDebugEmptyTarget?: (type: string, event: ObserveEvent | YEvent) => void
  onDebugEventListener?: (
    type: string,
    events: ObserveEvent[] | YEvent[]
  ) => void
}
export interface DocChangedListener {
  (events: YEvent[], next: (events: YEvent[]) => void, origin?: any): void
}

export interface ReactiveChangedListener {
  (
    event: ObserveEvent,
    index: number,
    events: ObserveEvent[],
    next: (event: ObserveEvent) => void
  ): void
}
export interface Store extends TRecord {
  /**
   * 上报错误
   * @param error 错误
   * @param silent 是否静默
   */
  raise?(error: Error, silent?: boolean): void
}
export type YArray = Y.Array<any>
export type YDoc = Y.Doc
export type YDocListener = Parameters<YMap['observeDeep']>[0]

export type YDocOptions = NonNullable<ConstructorParameters<typeof YDoc>[0]>

export type YEvent = Y.YEvent<any>

export type YMap = Y.Map<any>

export type YStackItemListener = Exclude<
  ReturnType<YUndoManager['on']>,
  (arg0: { redoStackCleared: boolean; undoStackCleared: boolean }) => void
>

export type YStruct = YArray | YMap

export type YUndoManager = Y.UndoManager

export type YValue = boolean | null | number | string | YStruct
